<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-card elevation="0">
      <div
        class="d-block"
        :style="`position: sticky; top: ${$vuetify.breakpoint.mdAndUp ? '64' : '56'}px; z-index: 2`"
      >
        <slot name="header" />
        <v-breadcrumbs
          v-if="breadcrumbs"
          :class="`${dark ? 'bluegray' : 'grey lighten-4'} pt-1 pb-0 pl-2 d-sm-none`"
          :items="breadcrumbs"
        />
        <v-card-actions
          :class="`${dark ? 'bluegray' : 'grey lighten-4'}`"
        >
          <v-breadcrumbs
            v-if="breadcrumbs"
            class="pl-2 d-none d-sm-block"
            :items="breadcrumbs"
          />
          <v-spacer />
          <slot name="actions" />
        </v-card-actions>
        <v-divider />
      </div>

      <v-card-text
        v-if="$slots.content"
        class="pa-4 pa-md-6"
      >
        <help-header />
        <slot name="content" />
      </v-card-text>
    </v-card>
    <slot />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import HelpHeader from '@/components/views/settings/HelpHeader.vue';

export default Vue.extend({
  name: 'SettingsForm',
  components: { HelpHeader },
  props: {
    breadcrumbs: { type: Object, required: false, default: null },
  },
  data: () => ({}),
  computed: {
    dark(): boolean { return this.$vuetify.theme.dark; },
  },
});

</script>
